import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations'
import { GeoMappingWithOptions } from 'partner360/components/filters'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../../../configs/translations'
import { setCockpitFilterGeoMappings } from '../../../../../../model'
import {
  selectCockpitFilterGeoMappings,
  selectCockpitGeoMappingItems,
} from '../../../../../../model/selectors'
import { CockpitFilterLabel } from '../../../cockpitFilterLabel/CockpitFilterLabel'

import styles from './CockpitGeoMappingFilter.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.geoMapping

export const CockpitGeoMappingFilter = ({ hideLabel = false }: { hideLabel?: boolean }) => {
  const dispatch = useAppDispatch()
  const selectedGeoMappings = useSelector(selectCockpitFilterGeoMappings)
  const geoMappingItems = useSelector(selectCockpitGeoMappingItems)

  const handleChangeGeoMapping = useCallback(
    (displayedIds: string[]) => {
      dispatch(setCockpitFilterGeoMappings(displayedIds))
    },
    [dispatch]
  )

  return (
    <div className={styles.root}>
      <CockpitFilterLabel
        text={hideLabel ? FINANCIAL_COCKPIT_TRANSLATION_KEYS.filterPanel.geo : KEYS.label}
        placeholderOnly={hideLabel}
      />
      <GeoMappingWithOptions
        label={
          hideLabel ? (
            <Translation span text={FINANCIAL_COCKPIT_TRANSLATION_KEYS.filterPanel.geo} />
          ) : undefined
        }
        options={geoMappingItems}
        values={selectedGeoMappings}
        onSelectChange={handleChangeGeoMapping}
      />
    </div>
  )
}
